import { render, staticRenderFns } from "./ProductDetailWidgetComponent.vue?vue&type=template&id=6fdb4228&"
import script from "./ProductDetailWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ProductDetailWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports